export default "__VITE_ASSET__da478361__"